import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class DashboardService extends GenericService {
    constructor() {
        super('/dashboard', axiosInstance);
    }

    // Get dashboard statistics
    async getStats() {
        try {
            const response = await this.axios.get(`${this.baseUrl}/stats`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get yearly sales data
    async getYearlySales(year = null) {
        try {
            const params = year ? `?year=${year}` : '';
            const response = await this.axios.get(`${this.baseUrl}/yearly-sales${params}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

  // Get sales by location data
  async getSalesByLocation() {
    try {
      const response = await this.axios.get(`${this.baseUrl}/sales-by-location`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new DashboardService();
